import React, { useState } from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box, PaddingSize } from '@styleseat/ui';

import { SearchPopoverModal } from '../../../consumer/search/SearchPopover';

import { ISearchTile } from '../SearchTile/SearchTile.types';
import { SearchTilesLine } from './SearchTilesLine';
import { HeaderText, Stack } from '../../../ui';
import analytics from '../../../../modules/analytics';

export type SearchTileGridProps = {
  isMobile: boolean;
  tiles: ISearchTile[][];
  imageHeight: number;
  imageWidth: number;
  space: PaddingSize;
  setBackground: boolean;
  onSelectTile?: (tile: ISearchTile) => void;
  isWide?: boolean;
};

/**
 * Displays a grid of search tiles. The last search title is dropped on mobile.
 */
const SearchTileGrid = ({
  tiles,
  isMobile,
  imageHeight,
  imageWidth,
  space,
  setBackground,
  isWide = false,
  onSelectTile = () => { },
}: SearchTileGridProps) => {
  const [shouldShowSearchModal, setShouldShowSearchModal] = useState(false);
  const backgroundColor = setBackground ? BrandColor.Bone : BrandColor.WhiteWash;

  const handleTilePressed = (tile: ISearchTile) => {
    const eventName = 'StyleSeat Homepage Search Tile Clicked';
    const data = { service: tile.text };
    analytics.track(eventName, data);
    onSelectTile(tile);
  };

  return (
    <Box
      paddingBottom={24}
      paddingTop={isMobile ? 0 : 32}
      width="100%"
      testID="search-tiles-container"
      style={{ backgroundColor, marginBottom: 24 }}
    >
      <Box
        style={{
          marginLeft: isWide ? 48 : 24,
          marginRight: isWide ? 48 : 24,
        }}
      >
        {shouldShowSearchModal && (
          <SearchPopoverModal onClose={() => setShouldShowSearchModal(false)} />
        )}
        <Box paddingBottom={24} paddingLeft={24}>
          <HeaderText
            level={2}
            weight="bold"
            testID="search-tiles-title"
            textAlign="center"
          >
            Find pros by service
          </HeaderText>
        </Box>
        <Stack space={24}>
          {tiles.map((tileGroup, idx) => (
          // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={`search-tile-line-${idx}`}>
              <SearchTilesLine
                tiles={tileGroup}
                imageHeight={imageHeight}
                imageWidth={imageWidth}
                onPress={handleTilePressed}
                space={space}
              />
            </React.Fragment>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default SearchTileGrid;
